import { io } from "socket.io-client";

// "undefined" means the URL will be computed from the `window.location` object
const URL = "http://thecharmingtreasure.in:4000";

export const socket = io(URL);
